import styled from "@emotion/styled";
import { desaturate, lighten } from "polished";
import { BodyBoldText, SecondaryText, TertiaryText } from "@silvertours/front-shared";
import { DeleteButtonInteractiveText } from "./DeleteButtonContent";
var SearchHistoryHeadline = /*#__PURE__*/ styled(TertiaryText, {
    target: "e1faawfx0"
})("padding-left:1.5rem;padding-right:1.5rem;");
var SearchHistoryListItem = /*#__PURE__*/ styled(BodyBoldText, {
    target: "e1faawfx1"
})("display:block;");
var SearchHistoryDate = /*#__PURE__*/ styled(SecondaryText, {
    target: "e1faawfx2"
})("display:block;");
var DeleteButtonContent = /*#__PURE__*/ styled(DeleteButtonInteractiveText, {
    target: "e1faawfx3"
})("margin-left:1.5rem;margin-right:1.5rem;display:inline-block;text-underline-offset:0.125rem;&:hover{text-decoration-line:underline;}");
var SearchHistoryWrapper = /*#__PURE__*/ styled("div", {
    target: "e1faawfx4"
})("display:", function(param) {
    var hidden = param.hidden;
    return hidden && "none";
}, ";border-color:", function(param) {
    var theme = param.theme;
    return lighten(0.065, desaturate(0.25, theme.color.primaryHighlight));
}, ";padding-top:1.5rem;padding-bottom:1.5rem;position:absolute;top:3.75rem;left:0;z-index:50;box-sizing:border-box;max-height:25rem;width:100%;overflow-y:auto;border-radius:0.5rem;border-width:0.125rem;box-shadow:0 4px 6px -1px rgb(0 0 0 / 10%),0 2px 4px -2px rgb(0 0 0 / 10%);background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";");
export { DeleteButtonContent, SearchHistoryHeadline, SearchHistoryListItem, SearchHistoryDate, SearchHistoryWrapper };
